export default {
  "hero.title": "USFans Spreadsheet — Trouvez, comparez et recherchez des ressources USFans",
  "hero.subtitle": "Explorez les ressources USFans Spreadsheet, des guides pratiques, des informations sur les vendeurs, des comparaisons, des informations de livraison et des conseils de sécurité — le tout organisé dans un centre de ressources facile à utiliser.",
  "hero.support": "Vous cherchez une façon plus claire de rechercher des ressources USFans ? Commencez par nos guides USFans Spreadsheet organisés, nos comparaisons et nos outils de recherche pratiques.",
  "hero.ctaPrimary": "Explorer USFans Spreadsheet",
  "hero.ctaSecondary": "Commencer par le guide débutant",
  "hero.badge": "Centre de ressources indépendant",

  "trust.1": "Ressource indépendante",
  "trust.2": "Guides mis à jour",
  "trust.3": "Contenu multilingue",
  "trust.4": "Recherche axée sur la sécurité",

  "jump.title": "Visitez notre boutique",
  "jump.subtitle": "Prêt à parcourir toute la gamme de produits ? Rendez-vous directement sur la boutique officielle.",
  "jump.primary": "USFans Spreadsheet",
  "jump.secondary": "Acheter maintenant",

  "whatIs.title": "Qu'est-ce que USFans Spreadsheet ?",
  "whatIs.text": "USFans Spreadsheet est couramment utilisé pour organiser et rechercher des informations sur les produits, les vendeurs et les achats. Notre centre de ressources aide les débutants et les utilisateurs expérimentés à comprendre les informations de la feuille de calcul, à comparer les options, à évaluer les détails importants et à effectuer des recherches plus approfondies.",
  "whatIs.cta": "Explorer le guide USFans Spreadsheet",

  "research.title": "Tout ce dont vous avez besoin pour rechercher USFans",
  "research.subtitle": "Un ensemble structuré de ressources couvrant les angles les plus importants lors de la recherche sur USFans.",
  "research.spreadsheet.title": "USFans Spreadsheet",
  "research.spreadsheet.text": "Explorez la ressource principale de la feuille de calcul et apprenez à lire et rechercher des informations.",
  "research.review.title": "Avis sur USFans",
  "research.review.text": "Comprenez ce qu'il faut vérifier lors de la recherche d'avis, de réputation et d'expériences utilisateur sur USFans.",
  "research.shipping.title": "Coût de livraison USFans",
  "research.shipping.text": "Découvrez quels facteurs peuvent affecter les coûts de livraison et quelles informations comparer.",
  "research.warehouse.title": "Entrepôt USFans",
  "research.warehouse.text": "Comprenez les informations liées à l'entrepôt, les concepts de stockage et les questions courantes.",
  "research.coupon.title": "Coupon USFans",
  "research.coupon.text": "Apprenez à rechercher des coupons, promotions et informations de réduction USFans.",
  "research.safety.title": "Sécurité USFans",
  "research.safety.text": "Identifiez les risques courants, les affirmations suspectes et les considérations de sécurité importantes.",

  "compare.title": "Comparez les ressources USFans avant de décider",
  "compare.text": "Différentes ressources peuvent fournir différents niveaux d'information. Utilisez nos guides de comparaison pour évaluer les catégories, les informations disponibles, les détails de contrôle qualité, les informations de livraison et les limitations potentielles avant de prendre une décision.",
  "compare.cta": "Voir les comparaisons USFans",

  "beginner.title": "Nouveau sur USFans ? Commencez ici.",
  "beginner.subtitle": "Un parcours simple en trois étapes pour rechercher avec plus de confiance.",
  "beginner.step1.title": "Trouvez",
  "beginner.step1.text": "Découvrez des ressources USFans Spreadsheet pertinentes.",
  "beginner.step2.title": "Comparez",
  "beginner.step2.text": "Comparez les informations disponibles et comprenez les différences.",
  "beginner.step3.title": "Recherchez",
  "beginner.step3.text": "Passez en revue la sécurité, la livraison, l'entrepôt et d'autres détails importants.",
  "beginner.cta": "Lire le guide complet pour débutants",

  "guides.title": "Guides USFans : avis, livraison, entrepôt et réductions",
  "guides.subtitle": "Des ressources dédiées aux sujets les plus recherchés.",
  "guides.review.title": "Avis sur USFans",
  "guides.review.text": "Ce qu'il faut vérifier avant de faire confiance à un avis.",
  "guides.shipping.title": "Coût de livraison USFans",
  "guides.shipping.text": "Les facteurs qui affectent les frais de livraison.",
  "guides.coupon.title": "Coupon USFans",
  "guides.coupon.text": "Comment rechercher des promotions.",
  "guides.discount.title": "Code promo USFans",
  "guides.discount.text": "Ce qu'il faut vérifier avant de l'utiliser.",
  "guides.warehouse.title": "Entrepôt USFans",
  "guides.warehouse.text": "Concepts de stockage et questions courantes.",
  "guides.legit.title": "USFans est-il légitime ?",
  "guides.legit.text": "Signaux de légitimité et de prudence.",

  "category.title": "Parcourir les produits par catégorie",
  "category.subtitle": "Accédez directement à n'importe quelle catégorie de produits de la boutique.",
  "category.dropdownLabel": "Choisissez une catégorie",
  "category.all": "Toutes les catégories",

  "article.title": "Derniers guides USFans Spreadsheet",
  "article.subtitle": "Des guides frais et originaux pour vous aider à rechercher en toute confiance.",

  "safety.title": "Centre de sécurité USFans Spreadsheet",
  "safety.text": "La recherche d'achats en ligne nécessite une vérification minutieuse. Notre centre de sécurité explique comment identifier les informations suspectes, évaluer les affirmations, protéger les informations personnelles et vérifier les détails importants avant d'agir.",
  "safety.cta": "Lire le guide de sécurité",

  "faq.title": "Questions fréquentes",
  "faq.q1": "Qu'est-ce que USFans Spreadsheet ?",
  "faq.a1": "USFans Spreadsheet est une façon d'organiser et de rechercher des informations sur les produits, les vendeurs et les achats en un seul endroit, ce qui facilite la comparaison des options et l'évaluation des détails.",
  "faq.q2": "Comment fonctionne USFans Spreadsheet ?",
  "faq.a2": "Il organise des informations structurées telles que les produits, les vendeurs, les prix et les détails de livraison en colonnes et en lignes, afin que vous puissiez analyser et comparer les données plus efficacement.",
  "faq.q3": "Comment lire une USFans Spreadsheet ?",
  "faq.a3": "Commencez par les en-têtes de colonnes, puis suivez chaque ligne pour comprendre les données d'un produit ou d'un vendeur spécifique. Vérifiez les colonnes clés comme le nom, le prix, le contrôle qualité et la livraison.",
  "faq.q4": "USFans est-il légitime ?",
  "faq.a4": "La légitimité dépend de la source que vous consultez. Vérifiez toujours les informations, cherchez des détails vérifiables et méfiez-vous des affirmations qui semblent trop belles pour être vraies.",
  "faq.q5": "Combien coûte la livraison USFans ?",
  "faq.a5": "Les coûts de livraison varient selon la destination, le poids, le transporteur et d'autres facteurs. Comparez plusieurs sources et confirmez le coût final avant d'acheter.",
  "faq.q6": "USFans propose-t-il des coupons ?",
  "faq.a6": "Des promotions et coupons peuvent apparaître au fil du temps. Vérifiez directement tout coupon ou code promo et méfiez-vous des offres non officielles ou invérifiables.",
  "faq.q7": "Où se trouve l'entrepôt USFans ?",
  "faq.a7": "Les détails de l'entrepôt peuvent changer. Consultez des sources officielles ou à jour pour obtenir les informations les plus précises sur l'emplacement et le stockage.",
  "faq.q8": "Comment vérifier les informations USFans ?",
  "faq.a8": "Comparez plusieurs sources indépendantes, recherchez des dates et des mises à jour, et confirmez les détails clés directement avant de prendre des décisions.",

  "final.title": "Prêt à explorer USFans Spreadsheet ?",
  "final.text": "Commencez par le guide USFans Spreadsheet, comparez les ressources pertinentes et apprenez à rechercher des informations importantes avec plus de confiance.",
  "final.ctaPrimary": "Explorer USFans Spreadsheet",
  "final.ctaSecondary": "Parcourir tous les guides"
};